// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
import { useMutation } from "@tanstack/react-query";
import { TrackManager } from "@x-mile/api-contract";
import type { PatchVehicleMutationVariables } from "../model";

export const usePatchVehicle = () => {
  const authHeaders = getAuthHeaders();
  const mutateResult = useMutation({
    mutationFn: (variables: PatchVehicleMutationVariables) =>
      TrackManager.patchVehicle(
        variables.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、リクエストボディをスネークケースに変換する
        keysToSnakeCase(variables.data),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return mutateResult;
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const usePatchVehicleMock = () => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getPatchVehicleMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return usePatchVehicle();
// };
